import { render, staticRenderFns } from "./join_ok.vue?vue&type=template&id=3cb59fde&"
import script from "./join_ok.vue?vue&type=script&lang=js&"
export * from "./join_ok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports